import React from 'react';
import './forms.css';

const SponsorForm = () => {
    return (
        <div className="forms">
            <iframe
                src="https://docs.google.com/forms/d/e/1FAIpQLScna4rWQlUeuj8BEWpbkw3MEl7zLuE3UBI4PkLDWwReCIIl3g/viewform?embedded=true"
                width="100%" /* Set the iframe width to 100% */
                height="100%" /* Allow the height to adapt to the container */
                frameBorder="0"
                title="Become a Sponsor or Exhibitor"
            >
                Loading…
            </iframe>
        </div>
    );
}

export default SponsorForm;